import communicationsForm from "./communicationsForm";
import contentPromotionForm from "./contentPromotionForm";
import instructionalBestPracticesForm from "./instructionalBestPracticesForm";
import integrationsForm from "./integrationsForm";
import keyTeamMembersForm from "./keyTeamMembersForm";
import measuringSuccessForm from "./measuringSuccessForm";
import professionalLearningForm from "./professionalLearningForm";

export {
  communicationsForm,
  instructionalBestPracticesForm,
  integrationsForm,
  keyTeamMembersForm,
  measuringSuccessForm,
  contentPromotionForm,
  professionalLearningForm,
};
